  import React, { useEffect } from "react";
  import Navbar from "components/Navbar";
  import Sidebar from "components/Sidebar";
  import Footer from "components/Footer";
  import { Outlet } from "react-router-dom";
  // import { useIsClientUser } from "app/hooks";
  import { useAppDispatch } from "app/hooks";
  import { setClientProfileDetails } from "app/slices/Client/thunk";

  export default function ClientPortalLayout() {
    const [open, setOpen] = React.useState(true);
    // const  isClientUser = useIsClientUser();
    const dispatch = useAppDispatch();

    React.useEffect(() => {
      window.addEventListener("resize", () =>
        window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
      );
    }, []);

    useEffect(() => {
      const currentUrl = window.location.pathname;
      if (!currentUrl.includes('/bio-data')) {
        dispatch(setClientProfileDetails());
      }
    }, [dispatch]);

    document.documentElement.dir = "ltr";

    return (
      <div className="flex h-full w-full">
        <Sidebar open={open} onClose={() => setOpen(false)} />
        <div className="h-full w-full bg-lightPrimary dark:!bg-navy-900">
          <main className="mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[333px]">
            <div className="h-full">
              <Navbar brandText="Client Portal" onOpenSidenav={() => setOpen(!open)} />
              <div className="pt-5s mx-auto mb-auto h-full min-h-[84vh] p-2 md:pr-2">
                <Outlet />
              </div>
              <div className="p-3">
                <Footer />
              </div>
            </div>
          </main>
        </div>
      </div>
    );
}